import React, { Component } from "react";
import { Button, Form, Image } from "react-bootstrap";
import DatePicker from "react-datepicker";
import configData from "../config.json";

import "./Abha.css";
export default class ProfileAbhaCollection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: "",
      lastname: "",
      gender: "",
      dateofbirth: "",
      address: "",
      district: "",
      personstate: "",
      pincode: "",
      mobileNumber: "",
      emailaddress: "",
    };
  }
  render() {
    return (
      <div>
        <div className="row mb-2">
          <div className="col-md-3 Inactive">
            <div className="widget_BG widget_BG_grid fill nav-icon">
              <p className="nav-label mt-2">Consent Collection</p>
            </div>
          </div>

          <div className="col-md-3 Inactive">
            <div className="widget_BG widget_BG_grid bi bi-file-richtext nav-icon">
              <p className="nav-label mt-2">Mobile Authentication</p>
            </div>
          </div>
          <div className="col-md-3 active-page">
            <div className="widget_BG widget_BG_grid bi bi-info-square nav-icon">
              <p className="nav-label mt-2">Profile Collection</p>
            </div>
          </div>
          <div className="col-md-3 Inactive">
            <div className="widget_BG widget_BG_grid bi bi-file-person nav-icon">
              <p className="nav-label mt-2">Process Completion</p>
            </div>
          </div>
        </div>
        <div className="row widget_BG widget_BG_grid d-flex m-0 mt-2">
          <div className="col-md-4">
            <Form.Group controlId="policyType">
              <Form.Label>Mobile Number</Form.Label>
              <Form.Control
                type="text"
                value={this.state.mobileNumber}
                onChange={this.handleMobileNumberChange}
                placeholder="Mobile Number"
              />
            </Form.Group>
          </div>
          <div className="col-md-4">
            <Form.Group>
              <Form.Label>Driving Licence number</Form.Label>
              <Form.Control
                type="text"
                name="drivinglicencenumber"
                id="drivinglicencenumber"
                value={this.state.drivinglicencenumber}
                onChange={(e) =>
                  this.handlefirstnameChange(
                    "drivinglicencenumber",
                    e.target.value
                  )
                }
              />
            </Form.Group>
          </div>
        </div>
        <div className="row widget_BG widget_BG_grid d-flex m-0 mt-2">
          <div className="col-md-4">
            <Form.Group>
              <Form.Label>First Name</Form.Label>
              <Form.Control
                type="text"
                name="firstName"
                id="firstName"
                value={this.state.firstName}
                onChange={(e) =>
                  this.handlefirstNameChange("firstName", e.target.value)
                }
              />
            </Form.Group>
          </div>
          <div className="col-md-4">
            <Form.Group>
              <Form.Label>Middle Name</Form.Label>
              <Form.Control
                type="text"
                name="middlename"
                id="middlename"
                value={this.state.middlename}
                onChange={(e) =>
                  this.handlemiddlenameChange("middlename", e.target.value)
                }
              />
            </Form.Group>
          </div>
          <div className="col-md-4">
            <Form.Group>
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                type="text"
                name="lastname"
                id="lastname"
                value={this.state.lastname}
                onChange={(e) =>
                  this.handlelastnameChange("lastname", e.target.value)
                }
              />
            </Form.Group>
          </div>
          <div className="col-md-4">
            <p>tex</p>
            <Image
              style={{
                width: "100%",
                marginLeft: "5px",
                marginTop: "10px",
              }}
              //src={configData.static_url + this.state.products.insurerlogo}
              alt="image"
            ></Image>
          </div>
          <div className="col-md-4 datepick">
            <Form.Group>
              <Form.Label>Date Of Birth</Form.Label>

              <div ClassName="custom-calendar">
                <DatePicker
                  selected={this.state.dateofbirth}
                  dropdownMode="select"
                  onChange={(date) => this.handledatesChange(date)}
                  className="myDatePicker"
                  id="dateofbirth"
                  showMonthDropdown
                  showYearDropdown
                  dateFormat="dd/MM/yyyy"
                  required
                  placeholderText="DD/MM/YYYY"
                />
              </div>
            </Form.Group>
          </div>
          <div className="col-md-4">
            <Form.Group controlId="policyType">
              <Form.Label>Gender</Form.Label>
              <Form.Control
                as="select"
                value={this.state.gender}
                onChange={this.handleGenderChange}
              >
                <option value="">Select</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="transgender">Transgender</option>
              </Form.Control>
            </Form.Group>
          </div>

          <div className="col-md-4">
            <Form.Group>
              <Form.Label>Address</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="address"
                id="address"
                value={this.state.address}
                onChange={(e) =>
                  this.handleGSTINnumberChange("address", e.target.value)
                }
              />
            </Form.Group>
          </div>
          <div className="col-md-4">
            <Form.Group>
              <Form.Label>Pincode </Form.Label>
              <Form.Control
                type="text"
                name="pincode"
                id="pincode"
                maxLength={6}
                value={this.state.pincode}
                onChange={(e) =>
                  this.handlePanNumberChange("pincode", e.target.value)
                }
              />
            </Form.Group>
          </div>
          <div className="col-md-4">
            <Form.Group>
              <Form.Label>District</Form.Label>
              <Form.Control
                type="text"
                name="district"
                id="district"
                maxLength={10}
                value={this.state.district}
                onChange={(e) =>
                  this.handledistrictChange("district", e.target.value)
                }
              />
            </Form.Group>
          </div>
          <div className="col-md-4">
            <Form.Group>
              <Form.Label>State</Form.Label>
              <Form.Control
                type="text"
                name="statecd"
                id="statecd"
                value={this.state.statecd}
                onChange={(e) =>
                  this.handlePanNumberChange("statecd", e.target.value)
                }
              />
            </Form.Group>
          </div>
        </div>
        <div className="row widget_BG widget_BG_grid d-flex m-0 mt-2">
          <div className="col-md-4">
            <Form.Group>
              <Form.Label>Driving Licence Frontside Upload</Form.Label>
              <Form.Control
                accept=".pdf,.jpg,jpeg,.png"
                type="file"
                onChange={this.handledlfrontsideupload}
                className="form-control"
                name="dlforntsideupload"
                id="dlfrontupload"
                //value={this.state.policyupload}
                //required="required"
              />
            </Form.Group>
          </div>
          <div className="col-md-4">
            <Form.Group>
              <Form.Label>Driving Licence-Backside Upload</Form.Label>
              <Form.Control
                type="file"
                accept=".pdf,.jpg,jpeg,.png"
                onChange={this.handledlbacksideupload}
                className="form-control"
                name="dlbacksideupload"
                id="dlbacksideupload"
                Label="Maximum size allowed for the attachement is 150KB."
                //value={this.state.policyupload}
                //required="required"
              />
            </Form.Group>
          </div>
          <i>
            Acepted .pdf,.jpg,jpeg,.png Maximum size allowed for the attachement
            is 150KB.
          </i>
        </div>
        <div className="row  widget_BG widget_BG_grid  m-0 mt-2">
          <div className="col-md-4">
            <Form.Group controlId="depreciationOpted">
              <Form.Check
                type="checkbox"
                className="chekboxlabel"
                name="depreciationOpted"
                label="Depreciation Reimbursement Opted in PIP"
                checked={this.state.depreciationOpted}
                onChange={this.handleCheckboxChange}
              />
            </Form.Group>
          </div>
        </div>
        <div className="row  widget_BG widget_BG_grid m-0 mt-2">
          <div className="col text-end">
            <Button className="rounded-0 m-1">Next</Button>
          </div>
        </div>
      </div>
    );
  }
}
